import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";

import NewBankSlip from 'assets/images/banner-acesso-boletos.jpg';

import {
  Container,
  Header,
  CloseIcon,
  Content,
  ContentImg,
} from "./styles";

const BannerNovoAcessoBoleto = ({ closeCallBack }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    const { deliveryType } = JSON.parse(
      localStorage.getItem("@UltragazEmpresarial:unitData")
    );

    if (deliveryType === "EMAIL") {
      setShow(true);
    }
  };

  useEffect(() => {
    const unitData = localStorage.getItem("@UltragazEmpresarial:unitData");
    let interval = null;
    if(!unitData) {
     interval = setInterval(() => {
        handleShow();
        if(interval) {
          clearInterval(interval)
        }
      }, [500])
      return;
    } else {
      handleShow();
    }
  }, []);

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
        if(closeCallBack) {
          closeCallBack();
        }
      }}
      size="lg"
      animation={false}
      centered
    >
      <Container>
        <Header>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={() => setShow(false)} />
        </Header>
        <Content>
          <ContentImg src={NewBankSlip} />
        </Content>
      </Container>
    </Modal>
  );
};

export default BannerNovoAcessoBoleto;
